import { ScrollableBar } from '../../components/ScrollableBar/ScrollableBar'
import { ScrollImage, ScrollItem } from '../../components/ScrollableBar/ScrollableBar.styles'
import { ScrollContainer } from './ScrollableHeader.styles'
import { Typography } from '../../style'
import iconBrandTicket from '../../img/icon-brand-ticket.svg'
import vrEarn from '../../img/graphic-vr-earn.svg'
import iconVrSpend from '../../img/icon-vr-spend.svg'

export const ScrollableHeader = () => (
  <ScrollContainer>
    <ScrollableBar>
      <ScrollItem>
        <ScrollImage src={iconBrandTicket} alt="" />
        <Typography.BodyBold>Book tickets for any train across Great Britain</Typography.BodyBold>
      </ScrollItem>
      <ScrollItem>
        <ScrollImage src={vrEarn} alt="" />
        <Typography.BodyBold>Earn Virgin Points with every £1 you spend</Typography.BodyBold>
      </ScrollItem>
      <ScrollItem>
        <ScrollImage src={iconVrSpend} alt="" />
        <Typography.BodyBold>Use your points to unlock discounts on future train travel</Typography.BodyBold>
      </ScrollItem>
    </ScrollableBar>
  </ScrollContainer>
)
